import SimpleTransition from "./SimpleTransition";
export default {
    SimpleTransition,
};
//# sourceMappingURL=Animate.js.map